// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userMenu .el-menu-item,\n.userMenu .el-submenu__title {\n  height: 40px;\n  line-height: 40px;\n}", ""]);
// Exports
module.exports = exports;
